var _g, _g2, _tspan, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "600px",
    height: "600px",
    viewBox: "0 0 200 200",
    style: {
      overflow: "hidden!important"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-wrapper"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-backs-single"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanwrap-move",
    transform: "matrix(1,0,0,1,0,-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanwrap"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-back-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-back"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanbody-back"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18144",
    d: "m170 180.3-27.3-6.9-18-9.9-1.5-28.2H76.8l-1.5 28.2-18 9.9-27.3 6.9-9.1 19.7-3 20h164.2l-3-20z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18145",
    d: "m76.8 135.3-1.5 28.2-18 9.9-27.3 6.9-9.1 19.7-3 20h14.6v-20l2.7-17.7 23.8-6.4 24.7-8.3 3.5-32.3z",
    fill: "#d19271",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-chinshadow-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18140",
    d: "m121.7 151.9 2.2-2.6-.7-14H76.8l-1 18.5 11.2 6.9h20.4z",
    fill: "#c27b55",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanbody-front"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18146",
    d: "m92.8 168.3 2 7.9 6.9 4.6s-8.5-3-8.7-3.6c-.2-.6-.2-8.9-.2-8.9z",
    fill: "#d19271",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-clothes-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18026",
    d: "m179.6 200-8.5-20-28.8-7.4-9.5-4.8-.1-1.5-8.3-8.8.2 3.5-1.1 12.2-7.6 7.9-9.1 1.9-2.1 5.7-2.1 2.9-7.5-9.3-10.7-1.2-5.8-7.3-3.2-13.1.2-3.2-8.3 8.8-.1 1.5-9.5 4.8L29 180l-8.6 20-3.4 20h165.9z",
    fill: "#386e77",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18027",
    d: "m29.9 200.7 3.6-10.8 24.9-9.6 7.2-3.2.3-2 11.5-5.7h.1l-2.1-8.7.2-3.2-8.3 8.8-.1 1.5-9.5 4.8L29 180l-8.6 20-3.4 20h12.6z",
    fill: "#265e68",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18028",
    d: "m132.8 167.8 2.7 19.2 1.2 8.7L125 188l-5.2-5.3-4.2-1.6 4 3.4-6.4 2.6-7.9 1.5 7-.6-8.7 11.8V220h1.7l-.8-19.8 7.8-12 1-.1 7.1-2.8 4.2 4.5 13.3 8.1-1.6-12.4-3.5-17.7zm-33.1 29.7 2.9-5.9-3.5 5-6.1-8.7-12.5-3.4 3.8-3.3-4.2 1.6L75 188l-11.7 7.7 1.2-8.7 2.7-19.2-3.4 17.7-1.6 12.4 13.3-8.1 4.6-4.9.5-.5 11.8 4.3 6.1 8.6-1.2.7 1.1 21.9h1.5l-1.3-21 1.1-1.4zm10.5-12.8-1.5-.8-.9 1.4 1.4 1 1-1.6zm-9.3 13.3 1.4 1 1-1.7-1.5-.8-.9 1.5zm-.8 18.6 1.4 1 1-1.7-1.5-.8-.9 1.5zm-69.7-35.3 6.8 21 1.2 17.7h1.4l-1.1-17.8-8.3-20.9zm130.5 19.3-1.2 19.4h1.9l1-19.2 7-18.2-8.7 18z",
    fill: "#184f58",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18029",
    d: "m127 162.5-1.1-1.4v13l-5.3 8 4.8 4.6s2.3-11.1 2.3-11.8c0-.7-.7-12.4-.7-12.4zm-53.2.1.5-2.3-1.8 2.5 1.2 13.4 2.1 9.5 3.8-4.3-3.9-6.1-1.9-12.7z",
    fill: "#4d7e86",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-head",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18041",
    d: "M60.9 93s-5.5-3-7.7-3.9c0 0-3.9 5.4-5.1 7.2 0 0 3.1 14.7 3.9 17.3l5 6.5 5.4-1.7 4.2-14.2L60.9 93z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18042",
    d: "M58.8 104.7c-.2-.4-6-10-6-10l-2.3 7.9 2.6-2.4 1.6 2.9s-.3 5-.2 5.5c0 .5 2.4 4.3 2.4 4.3l1.9-8.2z",
    fill: "#d19271",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18043",
    d: "m58.4 98-5.2-8.9c2.2.9 7.7 1.8 7.7 1.8l5.7 13.3-4.2 14.2-5.4 1.7 3.6-3.4L58.4 98z",
    fill: "#e1ac8f",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18044",
    d: "M139.1 93s5.5-3 7.7-3.9c0 0 3.9 5.4 5.1 7.2 0 0-3.1 14.7-3.9 17.3l-5 6.5-5.4-1.7-4.2-14.2 5.7-11.2z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18045",
    d: "M141.2 104.7c.2-.4 6-10 6-10l2.3 7.9-2.6-2.4-1.6 2.9s.3 5 .2 5.5c0 .5-2.4 4.3-2.4 4.3l-1.9-8.2z",
    fill: "#d19271",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18046",
    d: "m141.6 98 5.2-8.9c-2.2.9-7.7 1.8-7.7 1.8l-5.7 13.3 4.2 14.2 5.4 1.7-3.6-3.4 2.2-18.7z",
    fill: "#e1ac8f",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-wrap"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18123",
    d: "M143.4 84.8c-.2-10.2-5.3-24.8-5.3-24.8-6.9-11.6-19.7-19.5-19.7-19.5-7.2-1.5-18.4-2.3-18.4-2.3s-11.1.8-18.4 2.3c0 0-12.8 7.9-19.7 19.5 0 0-5.1 14.5-5.3 24.8l1 27.1 6.5 21.2 11.4 13.2 14.3 8.8h20.5l14.3-8.8 11.4-13.2 6.5-21.2.9-27.1z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18124",
    d: "M109.5 151.6H89.3l-12.1-8.1-8.3-12.9L63 111l-1.3-28.3 4.6-21.6 16.4-17.2 17.2-3.8 18.5.4c-7.2-1.5-18.4-2.3-18.4-2.3s-11.1.8-18.4 2.3c0 0-12.8 7.9-19.7 19.5 0 0-5.1 14.5-5.3 24.8l1 27.1 6.5 21.2 11.4 13.2 14.3 8.8h20.5l14.3-8.8 11.4-13.2-12.6 11.7-13.9 6.8z",
    fill: "#d19271",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18125",
    d: "m88.8 141 6.5-2.8h9.3l7.3 2.2-6.6-4H94.7z",
    fill: "#e1ac8f",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mouth-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mouth-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18574",
    d: "m111.71 128.99-5.84-1.83-3.28-.34h-5.18l-3.28.34-5.68 1.83-2.35 1 1.57 2.22 7.2 3.17h10.26l7.2-3.17 1.57-2.22z",
    fill: "#da7c87",
    strokeWidth: "none",
    opacity: 1,
    transform: "translate(0 2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18575",
    d: "m83.15 129.56 6.2 1.7h19.9l7.6-2.1-8.3 1.1h-19.3z",
    fill: "#cb5f6c",
    strokeWidth: "none",
    opacity: 1,
    transform: "translate(0 2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18923",
    d: "M92.5 96.6 88 92.7S75 92 74.7 92s-6.3 4.2-6.1 4.4c.2.2 6.5 3 9 3.5 0 0 3.8 0 7.7-.8 2.8-.8 5.7-1.9 7.2-2.5z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18161",
    d: "M82.9 89.5h-4L76 92.4v4.1l2.9 2.8h4l2.9-2.8v-4.1z",
    fill: "#4e60a3",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18162",
    d: "M86.1 96.5v-2c0-.7 0-1.4-.1-2v-.2c-.5-.5-1-.9-1.5-1.4-.2-.2-.5-.5-.8-.7-.2-.2-.5-.4-.8-.7-.3 0-.7 0-1-.1s-.7 0-1-.1c-.7 0-1.4-.1-2.1-.1h-.1l-.1.1c-.5.5-1 .9-1.5 1.4l-.7.7-.7.7-.1.1v.1l.1 2c0 .7.1 1.4.1 2l.7.7.7.7c.5.5.9 1 1.4 1.5h.1c.7 0 1.4.1 2 .1H83l.1-.1 1.5-1.4.7-.7.7-.7.1-.1v.2zm-1.2.5-.7.7-1.3 1.4H81c-.7 0-1.3 0-2 .1-.5-.4-1-.9-1.4-1.4l-.7-.7-.7-.7c0-.7 0-1.3.1-2l.1-1.9.7-.7.7-.7 1.4-1.4c.6 0 1.3 0 1.9-.1.3 0 .7 0 1-.1.3 0 .7 0 1-.1l.7.8c.2.2.5.5.7.8.4.5.9.9 1.3 1.4 0 .7 0 1.3-.1 1.9v1.9l-.8.8z",
    fill: "#253984",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18163",
    d: "m82.6 93.2.4 1.5-.8 1.4-1.6.4-1.4-.8-.4-1.6.8-1.4 1.6-.4z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18164",
    d: "m80.6 96.7-1.5-.9-.4-1.7.9-1.5 1.7-.4 1.5.9.4 1.7-.9 1.5-1.7.4zm-1.2-1.1 1.3.8 1.4-.4.8-1.3-.4-1.4-1.3-.8-1.4.4-.8 1.3.4 1.4z",
    fill: "#253984",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18165",
    d: "m78.7 90.9.8-.4 1.1 2.4-.8.4-1.1-2.4z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18166",
    d: "M81.2 95.5h1v1h-1v-1z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18931",
    d: "M67.1 89.3v11.9l7.9 8.4h11.2l7.9-8.4V89.3l-7.9-8.4H75l-7.9 8.4zm1.5 7c-.2-.2 5.9-4.4 6.1-4.4s13.3.8 13.3.8l4.5 3.9c-1.5.7-4.4 1.8-7.2 2.4-3.9.9-7.7.8-7.7.8-2.5-.4-8.7-3.3-9-3.5z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18932",
    d: "m93 96.8-1.2-.5-4.1-3.4-12.9-.6-4.5 3.1-1.1 1 6.3 2.8-2.9-.7-4.7-2.1 1.8-1.8 5-3 13.3.9z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18933",
    d: "m91.5 94.7-3.8-4.5-9.7-.1-2.9 1.3 3.4-.9 9.1.2z",
    fill: "#e1ac8f",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18924",
    d: "m107.5 96.6 4.5-3.9s13-.7 13.3-.7 6.3 4.2 6.1 4.4c-.2.2-6.5 3-9 3.5 0 0-3.8 0-7.7-.8-2.8-.8-5.7-1.9-7.2-2.5z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18167",
    d: "M121.1 89.5H117l-2.9 2.9v4.1l2.9 2.8h4.1l2.8-2.8v-4.1z",
    fill: "#4e60a3",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18168",
    d: "M124.2 96.5v-2c0-.7 0-1.4-.1-2v-.1l-.1-.1c-.5-.5-1-.9-1.5-1.4-.2-.2-.5-.5-.8-.7-.2-.2-.5-.4-.8-.7-.3 0-.7 0-1-.1s-.7 0-1-.1c-.7 0-1.4-.1-2.1-.1h-.1l-.1.1c-.5.5-1 .9-1.5 1.4l-.7.7-.7.7-.1.1v.1l.1 2c0 .7.1 1.4.1 2l.7.7.7.7c.5.5.9 1 1.4 1.5h.1c.7 0 1.4.1 2 .1h2.1l.1-.1 1.5-1.4.7-.7.7-.7.1-.1.3.2zm-1.2.5-.7.7-1.3 1.4h-1.9c-.7 0-1.3 0-2 .1-.5-.4-1-.9-1.4-1.4l-.7-.7-.7-.7c0-.7 0-1.3.1-2l.1-1.9.7-.7.7-.7 1.4-1.4c.6 0 1.3 0 1.9-.1.3 0 .7 0 1-.1.3 0 .7 0 1-.1l.7.8c.2.2.5.5.7.8.4.5.9.9 1.3 1.4 0 .7 0 1.3-.1 1.9v1.9l-.8.8z",
    fill: "#253984",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18169",
    d: "m120.7 93.2.4 1.5-.8 1.4-1.6.4-1.4-.8-.4-1.6.9-1.4 1.5-.4z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18170",
    d: "m118.7 96.7-1.5-.9-.4-1.7.9-1.5 1.7-.4 1.5.9.4 1.7-.9 1.5-1.7.4zm-1.2-1.1 1.3.8 1.4-.4.8-1.3-.4-1.4-1.3-.8-1.4.4-.8 1.3.4 1.4z",
    fill: "#253984",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18171",
    d: "m116.8 90.9.8-.4 1.1 2.4-.8.4-1.1-2.4z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18172",
    d: "M119.3 95.5h1v1h-1v-1z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18934",
    d: "M125 80.8h-11.2l-7.9 8.4v11.9l7.9 8.4H125l7.9-8.4V89.3l-7.9-8.5zm-2.6 19s-3.8 0-7.7-.8c-2.8-.6-5.7-1.7-7.2-2.4l4.5-3.9s13-.7 13.3-.7 6.3 4.2 6.1 4.4-6.5 3-9 3.4z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18937",
    d: "m107 96.8 1.2-.5 4.1-3.4 12.9-.6 4.5 3.1 1.1 1-6.3 2.8 2.9-.7 4.7-2.1-1.8-1.8-5-3-13.3.9z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18938",
    d: "m108.5 94.7 3.8-4.5 9.7-.1 2.9 1.3-3.4-.9-9.1.2z",
    fill: "#e1ac8f",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-facehighlight-single"
  }), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left-rotate",
    transform: "matrix(1,1.7453292519943295e-9,-1.7453292519943295e-9,1,1.470439912054644e-7,-1.3823007805058296e-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18967",
    d: "m93.58 85.39-1.3 2.72-18.78-7.17-10.68 3.59 11.09-5.86z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right-rotate",
    transform: "matrix(1,1.7453292519943295e-9,-1.7453292519943295e-9,1,1.470439912054644e-7,-2.10835779057561e-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18968",
    d: "m106.42 85.39 1.3 2.72 18.78-7.17 10.68 3.59-11.09-5.86z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beardwrap"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beard-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beard-single"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mustache-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mustache-single"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-nose-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-nose-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18212",
    d: "m104.02 101.62 6.37 11.09-2.65 3.58-2.86-2.01-1.86 3.72h-6.3l-1.79-3.72-2.93 1.86-2.58-3.65 6.73-11.37 3.86-1.65z",
    fill: "#f0c7b1",
    strokeWidth: "none",
    opacity: 1,
    transform: "translate(0 1)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18213",
    d: "m104.31 101.38-1.02-.41 6.61 11.51-2.05 2.93-1.77-1.21.28-1.31-1.4.6-2.05 4.04-2.7.1-3.2-.1-2.05-4.04-1.4-.6.28 1.31-1.77 1.21-2.04-2.93 6.61-11.51.42-13.8-1.45 14.21-6.7 11.3 3.26 4.24 2.79-2.01 1.58 3.53h6.84l1.58-3.53 2.8 2.01 3.26-4.24z",
    fill: "#d19271",
    strokeWidth: "none",
    opacity: 1,
    transform: "translate(0 1)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath18214",
    d: "m96.51 113.01 1.67.79 3.93.1 1.96-.89-.74-3.01-1.27-3.98-2.6 5.23z",
    fill: "#f8d5c3",
    strokeWidth: "none",
    opacity: 1,
    transform: "translate(0 1)",
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-front"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath19156",
    d: "M143.01 63.98c-2.54-5.83-19.15-23.84-19.15-23.84L100 36.33l-23.86 3.8s-16.61 18-19.15 23.84l-.93 24.3 4.58 4.03h2.56l.73-24.9 17.21-16.84 7.32 8.24L100 60.55l11.54-1.75 7.32-8.24 17.21 16.84.73 24.9h2.56l4.58-4.03-.93-24.29z",
    fill: "#1b141c",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath19157",
    d: "M123.86 40.14 100 36.33l-9.09 1.45-11.22 4.57s8.72 13.88 9.72 13.88c.99 0 12.49 1.78 13.48 1.59.99-.2 8.33-.99 8.33-.99l8.33-7.53 18.04 18.24.92 24.77h.86l4.58-4.03-.93-24.3c-2.55-5.84-19.16-23.84-19.16-23.84z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-glasses-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-glasses-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath19058",
    d: "m65.4 93.1.5 5.4 3.7 4.7 9.8 2.1 7.9-1 6.2-4.1 1.9-6.1-3.2-3.1-8.4-1.1H77.4l-5.2-.1-4.4.9-2.4 2.4z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath19059",
    d: "m134.6 93.1-.5 5.4-3.7 4.7-9.8 2.1-7.9-1-6.2-4.1-1.9-6.1 3.3-3.1 8.4-1.1H122.7l5.2-.1 4.4.9 2.3 2.4z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath19060",
    d: "M95.6 93.9s3.8-1.7 8.6 0l.2 1s-5.7-.9-9 .1l.2-1.1z",
    fill: "#070201",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath19061",
    d: "m92.3 90.6-8.6-1.1h-6.4l-5.3-.2-4.5.9-2.2 2.3h-2.5v2.1h2.4v.1l.4 3.9 3.9 4.9 9.9 2.1h.1l8-1.1 6.4-4.3 2.1-6.4-3.7-3.2zm.9 9.3-6 4-7.8 1-9.6-2-3.6-4.5-.5-5.2 2.1-2.3L72 90l5.2.1h6.4l8.3 1.1 3.1 2.9-1.8 5.8z",
    fill: "#26120b",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath19062",
    d: "m104.1 94 2.1 6.4 6.4 4.3 8 1.1h.1l9.9-2.1 3.9-4.9.4-3.9v-.1h2.4v-2.1h-2.5l-2.2-2.3-4.5-.9-5.3.1h-6.4l-8.6 1.1-3.7 3.3zm.8.2 3.1-2.9 8.3-1.1h6.4l5.2-.1 4.2.9 2.1 2.3-.5 5.2-3.6 4.5-9.6 2-7.8-1-6-4-1.8-5.8z",
    fill: "#26120b",
    strokeWidth: "none",
    opacity: 1
  }))))))), /*#__PURE__*/React.createElement("rect", {
    id: "svga-credit-rect",
    width: 200,
    height: 15,
    x: 0,
    y: 185,
    fill: "#ecf0f1",
    opacity: 0.5,
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "svga-credit-text",
    fontFamily: "Avenir Next, Roboto, Helvetica, Arial, sans-serif",
    fontSize: "10px",
    textAnchor: "start",
    fontWeight: 400,
    size: "10px",
    anchor: "start",
    weight: 400,
    fill: "#333333",
    x: 33.410400390625,
    y: 182.63856887817383,
    style: {
      display: "none"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "SvgjsTspan17998",
    dy: 13,
    x: 33.410400390625
  }, "Created on AvatarMaker.com")))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs17945"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.c7a0e262f89f32b9f773f9bea4d22104.svg";
export { ForwardRef as ReactComponent };